export default __webpack_public_path__ + "static/media/phone.86e6a3b9.png";